<div class="dialog-container">
    <div class="dialog-header">
        <div class="dialog-header__title">
            <div *ngIf="!isScheduled; else videochatTitle">
                <h1
                    mat-dialog-title
                    class="modal-title"
                    [ngStyle]="setMyStyles()"
                >
                    <mat-icon class="icon__service" *ngIf="data.icon">{{
                        data.icon
                    }}</mat-icon>
                    {{ data.title | titlecase }}
                </h1>
            </div>
            <ng-template #videochatTitle>
                <h1
                    mat-dialog-title
                    class="modal-title"
                    [ngStyle]="setMyStyles()"
                >
                    <mat-icon class="icon__service" *ngIf="data.icon">{{
                        data.icon
                    }}</mat-icon>
                    <span *ngIf="isScheduled"
                        >Video Interpretariato in LIS</span
                    >
                    <span *ngIf="!isScheduled">Richiesta Immediata</span>
                </h1>
            </ng-template>
        </div>
        <div class="close-dialog">
            <button
                mat-icon-button
                mat-dialog-close
                class="button-close--outlined"
                color="primary"
                aria-label="Chiudi"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="isScheduled; else immediateTicket">
        <div mat-dialog-content>
            <form
                (ngSubmit)="onYesClick()"
                class="mat-dialog-content"
                [formGroup]="formGroupVideoChatScheduled"
            >
                <div class="dialog-content__container">
                    <div class="form__grid">
                        <mat-form-field class="fo-field" *ngIf="isScheduled">
                            <mat-label>Data</mat-label>
                            <input
                                matInput
                                [matDatepicker]="picker"
                                [min]="today"
                                formControlName="date"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="picker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroupVideoChatScheduled
                                        ?.get('date')
                                        ?.hasError('required')
                                "
                                >Campo obbligatorio</mat-error
                            >
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroupVideoChatScheduled
                                        ?.get('date')
                                        .hasError('invalidDate')
                                "
                                >Le prenotazioni devono essere richieste
                                {{ minHoursForTicketSchedulation }} ore prima
                                dell’evento.
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="fo-field">
                            <mat-label>Orario di inizio richiesta</mat-label>
                            <input
                                matInput
                                type="time"
                                formControlName="schedule_hours"
                                required
                            />
                            <mat-icon matSuffix>access_time</mat-icon>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroupVideoChatScheduled.controls[
                                        'schedule_hours'
                                    ]?.hasError('required')
                                "
                            >
                                Campo obbligatorio
                            </mat-error>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroupVideoChatScheduled.controls[
                                        'schedule_hours'
                                    ]?.hasError('IsBefore')
                                "
                            >
                                L'orario di inizio non può essere retroattiva
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="fo-field">
                            <mat-label>Durata del Servizio</mat-label>
                            <mat-select formControlName="duration" required>
                                <mat-option
                                    *ngFor="let option of duration"
                                    [value]="option"
                                    >{{ option }}</mat-option
                                >
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="fo-field">
                            <mat-label>Categoria</mat-label>
                            <mat-select formControlName="id_category" required>
                                <mat-option
                                    *ngFor="let cat of categories"
                                    [value]="cat.id"
                                >
                                    {{ cat.category }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroupVideoChatScheduled.controls[
                                        'id_category'
                                    ]?.hasError('required')
                                "
                            >
                                Campo obbligatorio
                            </mat-error>
                        </mat-form-field>
                        <div
                            *ngIf="isScheduled"
                            formGroupName="schedulationDetail"
                            class="form__section"
                        >
                            <div *ngIf="is_remote" class="radio__row">
                                <mat-radio-group
                                    formControlName="is_remote"
                                    class="radio__group"
                                >
                                    <mat-radio-button [value]="true"
                                        >A distanza</mat-radio-button
                                    >
                                    <mat-radio-button [value]="false">
                                        In presenza
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            <fieldset
                                *ngIf="
                                    !formGroupVideoChatScheduled.get(
                                        'schedulationDetail.is_remote'
                                    ).value
                                "
                                formGroupName="detail"
                                class="scheduler-border presence__fieldset"
                            >
                                <mat-form-field class="fo-field">
                                    <mat-label>Città</mat-label>
                                    <input
                                        matInput
                                        type="text"
                                        formControlName="city"
                                    />
                                    <mat-error
                                        class="error-message"
                                        *ngIf="
                                            formGroupVideoChatScheduled?.get(
                                                'schedulationDetail.detail.city'
                                            )?.invalid
                                        "
                                    >
                                        Campo obbligatorio
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="fo-field">
                                    <mat-label>Indirizzo</mat-label>
                                    <input
                                        matInput
                                        type="text"
                                        formControlName="address"
                                    />
                                    <mat-error
                                        class="error-message"
                                        *ngIf="
                                            formGroupVideoChatScheduled?.get(
                                                'schedulationDetail.detail.address'
                                            )?.invalid
                                        "
                                    >
                                        Campo obbligatorio
                                    </mat-error>
                                </mat-form-field>
                                <mat-form-field class="fo-field">
                                    <mat-label
                                        >Motivazione richiesta in
                                        presenza</mat-label
                                    >
                                    <textarea
                                        matInput
                                        formControlName="reason"
                                    ></textarea>
                                </mat-form-field>
                            </fieldset>
                        </div>
                        <mat-form-field class="fo-field">
                            <mat-label>Note</mat-label>
                            <textarea
                                matInput
                                matTextareaAutosize
                                matAutosizeMinRows="4"
                                matAutosizeMaxRows="4"
                                type="text"
                                formControlName="note"
                            ></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form__footer">
                    <div *ngIf="!willBeOpened" class="form__footer__warning">
                        Per la data o l'orario selezionato il servizio potrebbe
                        non essere disponibile
                    </div>
                    <div class="form__footer__actions">
                        <button
                            type="submit"
                            class="fo-btn fo-btn--primary"
                            [disabled]="
                                !formGroupVideoChatScheduled?.valid ||
                                isSubmitting
                            "
                        >
                            Procedi
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <ng-template #immediateTicket>
        <div mat-dialog-content>
            <form (ngSubmit)="onYesClick()" [formGroup]="formGroup">
                <div class="form__body">
                    <div class="form__grid">
                        <mat-form-field class="fo-field">
                            <mat-label>Numero da chiamare</mat-label>
                            <input
                                matInput
                                type="text"
                                formControlName="phone"
                                required
                            />
                            <mat-icon matSuffix>local_phone</mat-icon>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroup?.controls['phone']?.hasError(
                                        'required'
                                    )
                                "
                                >Campo obbligatorio
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Categoria</mat-label>
                            <mat-select formControlName="category" required>
                                <mat-option
                                    *ngFor="let cat of categories"
                                    [value]="cat.id"
                                >
                                    {{ cat.category }}
                                </mat-option>
                            </mat-select>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroup?.controls['category']?.hasError(
                                        'required'
                                    )
                                "
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>

                        <mat-form-field class="fo-field">
                            <mat-label>Descrizione</mat-label>
                            <textarea
                                matInput
                                matTextareaAutosize
                                matAutosizeMinRows="4"
                                matAutosizeMaxRows="4"
                                type="text"
                                formControlName="description"
                                required
                            ></textarea>
                            <mat-error
                                class="error-message"
                                *ngIf="
                                    formGroup?.controls[
                                        'description'
                                    ]?.hasError('required')
                                "
                                >Campo obbligatorio</mat-error
                            >
                        </mat-form-field>
                    </div>
                </div>
                <div class="form__footer">
                    <div class="form__footer__actions">
                        <button
                            type="submit"
                            class="fo-btn fo-btn--primary"
                            [disabled]="!formGroup?.valid || isSubmitting"
                        >
                            Procedi
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </ng-template>
</div>
